import { useFormContext } from './form';
import Pumps from '../../Vessels/Single/Rows/Pumps';
import React from 'react';
import { orange500 } from 'material-ui/styles/colors';

export function FormPumps() {
    const form = useFormContext();
    let { pumps } = form.values;
    if (!pumps || !pumps.length) {
        pumps = [{ capacity: '', quantity: '', type: '' }];
    }

    return (
        <div className="row">
            <div className="col-xs-12">
                <Pumps
                    type="cargo"
                    pumps={pumps}
                    confirmed={false}
                    changeField={(changes) => {
                        const change = Array.isArray(changes) ? changes[0] : changes;

                        let value;

                        const match = change.field.match(/\[(\d+)\]\.(\w+)/);
                        if (match) {
                            const index = +match[1];
                            const prop = match[2];
                            value = pumps.map((pump, i) =>
                                (i === index
                                    ? { ...pump, [prop]: change.value }
                                    : pump));
                        } else {
                            ({ value } = change);
                        }

                        form.onChange({
                            field: 'pumps',
                            value,
                        });
                    }}
                    underStyle={{ borderColor: orange500 }}
                />
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./app/components/common/Form/FormPumps.jsx